import ClientDetails from './ClientDetails'
import FarmDetails from './FarmDetails'
import AnimalNumbers from './AnimalNumbers'
import HistoricProduction from './HistoricProduction'
import MastitisMilkQuality from './MastitisMilkQuality'
import ReproductionPlanning from './ReproductionPlanning'
import TraceElements from './TraceElements'
import WelfareMonitoring from './WelfareMonitoring'
import AnimalHealth from './AnimalHealth'
import PreventiveHealthAndVacination from './PreventiveHealthAndVacination'
import YoungStock from './YoungStock'
import DrugAllocations from './DrugAllocations'


export const WCSummaryComponents = {
  ClientDetails,
  FarmDetails,
  AnimalNumbers,
  HistoricProduction,
  MastitisMilkQuality,
  ReproductionPlanning,
  TraceElements,
  WelfareMonitoring,
  AnimalHealth,
  PreventiveHealthAndVacination,
  YoungStock,
  DrugAllocations,
}
